export const HOME = '/';
export const ADD = '/add-item';
export const LIST = '/list';
export const ADMIN = '/admin';
export const LOGIN = '/login';
export const PERSON = '/person';
export const PEOPLE = '/people';
export const ACTIVATE = '/activate';
export const FORGOT_PASSWORD = '/forgot';
export const CHANGE_PASSWORD = 'change-password';